export class LocalDate {
  static toISOString(): string {
    const date = new Date();
    const offsetMs = date.getTimezoneOffset() * 60000;
    const localISOTime = new Date(date.getTime() - offsetMs).toISOString().slice(0, -1);

    return localISOTime;
  }
}
